import axiosInstance from '@api/axios-instance.ts';
import { FolderModel, MediaModel } from '@models/media-library.model.ts';
import { ApiParams, ApiResponse } from '@models/api.model.ts';
import { MediaApiParams } from '@store/media-library-store/media-library.model.ts';

export const getMediaLibraryFolders = async (
  id: string | null | undefined,
  params: Omit<MediaApiParams, 'id'>
): Promise<any> => {
  const url = id
    ? `/media-library/folders/getter/${id}`
    : `/media-library/folders/getter`;
  const response = await axiosInstance.get(url, { params });
  return response.data;
};

export const getMediaLibraryMedia = async (
  id: string | null | undefined,
  params: Omit<MediaApiParams, 'id'>
): Promise<any> => {
  const url = id
    ? `/media-library/media-library/getter/${id}`
    : `/media-library/media-library/getter`;
  const response = await axiosInstance.get(url, { params });
  return response.data;
};

export const getMediaLibraryMoveTreeData = async (): Promise<any> => {
  const response = await axiosInstance.get(`/media-library/folders/tree`);
  return response.data;
};

export const getMedia = async (
  params?: ApiParams
): Promise<ApiResponse<any>> => {
  const response = await axiosInstance.get('/media-library/getter', { params });
  return response.data;
};

export const createFolder = async (body: {
  name: string;
  parentId: string;
}): Promise<FolderModel> => {
  return await axiosInstance.post(`/media-library/folders`, body);
};

export const renameFolder = async (
  body: { name: string; id: string },
  id: string
): Promise<FolderModel> => {
  return await axiosInstance.put(`/media-library/folders/${id}`, body);
};

export const moveFolder = async (body: any): Promise<any> => {
  return await axiosInstance.put(`/media-library/folders/move`, body);
};

export const renameMedia = async (
  body: { name: string },
  id: string
): Promise<MediaModel> => {
  return await axiosInstance.put(`/media-library/media-library/${id}`, body);
};

export const moveMedia = async (body: any): Promise<any> => {
  return await axiosInstance.put(`/media-library/media-library/move`, body);
};

export const deleteFolder = async (ids: string[]): Promise<void> => {
  const data = { folderIds: ids };
  return await axiosInstance.delete(`/media-library/folders/ids`, { data });
};

export const deleteMedia = async (ids: string[]): Promise<void> => {
  const data = { ids: ids };
  return await axiosInstance.delete(`/media-library/file/multiple`, { data });
};

export const deleteMediaByPath = async (data: any): Promise<void> => {
  return await axiosInstance.delete(`/media-library/file`, { data });
};

export const uploadByUrl = async (body: { url: string }): Promise<Blob> => {
  const response = await axiosInstance.post(
    `/media-library/file/download-by-url`,
    body,
    {
      responseType: 'blob'
    }
  );
  return response.data;
};
